<template>
  <div class="tree-view">
    <CheckableTreeViewItem
      ref="treeView"
      :collapsed="true"
      :data="data[0]"
      :form-type="formType"
      :depth="0"
      :numbering="getNumbering()"
      :pretty-display="prettyDisplay" />
  </div>
</template>

<script>
export default {
  name: 'CheckableTreeView',

  props: {
    formType: String,
    data: {
      required: true,
      type: Array
    },
    numbering: {
      default: '',
      type: [String, Number]
    },
    prettyDisplay: { default: false }
  },

  data: () => ({
    badge: null,
    selection: null
  }),

  computed: {
    state () {
      return this.$refs.treeView.state
    },

    treeView () {
      return this.$refs.treeView
    }
  },

  methods: {
    getMask () {
      return this.treeView.getMask(this.data[0], [])
    },

    refresh () {
      this.treeView.refresh()
    },

    getNumbering () {
      // If has focus, use focussed element's numbering.
      if (this.focus && this.focus.getNumbering) {
        return this.focus.getNumbering()
      }

      return this.numbering
    },

    hasChildren () {
      return Object.keys(this.children).length > 0
    },

    notifySelection (item) {
      this.selection = item
      this.$emit('selection', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/CheckableTreeView.vue